import { createSelector } from '@reduxjs/toolkit'

import type { MatterArtifactVersionSelection } from '@/agent-v2/store/schemas'
import { selectAgentV2TranscriptMessages } from '@/agent-v2/store/selectors'
import type { RootState } from '@/store/store'
import type { AgentV2MatterArtifactEditProposal } from './slice'

type ProposalSelectorProps = {
  conversationId: string
  sourceMatterArtifactVersionId?: string
}

export type AgentV2MatterArtifactEditProposalReviewContext = {
  proposal: AgentV2MatterArtifactEditProposal
  matterArtifactSelection: MatterArtifactVersionSelection
}

export const selectAgentV2MatterArtifactEditProposal = (state: RootState, props: ProposalSelectorProps) =>
  state.agentV2MatterArtifactEditProposalsState.byConversationId[props.conversationId]

export const selectAgentV2MatterArtifactEditProposalReviewContext = createSelector(
  [selectAgentV2MatterArtifactEditProposal, selectAgentV2TranscriptMessages, (_state: RootState, props: ProposalSelectorProps) => props],
  (proposal, messages, props): AgentV2MatterArtifactEditProposalReviewContext | null => {
    if (!proposal) return null
    if (props.sourceMatterArtifactVersionId && proposal.sourceMatterArtifactVersionId !== props.sourceMatterArtifactVersionId) return null

    const matterArtifactSelection = messages.find(
      (message) => message.role === 'user' && message.turnId === proposal.originatingTurnId
    )?.matterArtifactSelection
    if (
      !matterArtifactSelection ||
      matterArtifactSelection.matter_artifact_id !== proposal.matterArtifactId ||
      matterArtifactSelection.matter_artifact_version_id !== proposal.sourceMatterArtifactVersionId
    ) {
      return null
    }

    return { proposal, matterArtifactSelection }
  }
)
